
import { map, reduce } from 'lodash'
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import DssIcon from '@/components/atoms/DssIcon.vue'
export default defineComponent({
  components: {
    DssIcon,
  },
  props: {},
  setup (props, context) {
    const store = useStore()

    const tagList = computed(() => {
      const tagList = store.state.myCollectionInfo.tagList
      const itemList = store.state.myCollectionInfo.itemList

      return map(tagList, (tagItem, tagId) => {
        const hit = reduce(itemList, (res, item) => {
          if (
            item.tagIds.filter((id: number) => {
              return tagId === String(id)
            }).length
          ) res++

          return res
        }, 0)

        return {
          id: Number(tagId),
          label: tagItem,
          hit
        }
      })
    })

    const onTagSelected = (id: number) => {
      store.commit('MY_COLLECTION_SELECTED_TAG', id)
      context.emit('tagSelected')
    }

    return {
      onTagSelected,
      tagList,
    }
  },
})
